import { Controller } from "@hotwired/stimulus";
import PhotoSwipeLightbox from "photoswipe/lightbox";

// Connects to data-controller="gallery"
export default class extends Controller {
  initialize() {
    const lightbox = new PhotoSwipeLightbox({
      gallery: this.element,
      children: "a",
      pswpModule: () => import("photoswipe"),
    });
    lightbox.init();
  }
}
